import { requestAsync } from 'redux-query';
import cfg from 'cfg';
import auth from 'dash-front/auth';

export const fetchPostPredictions = campaignId =>
    requestAsync({
        queryKey: `${campaignId}/postPredictions`,
        url: `${
            cfg.campaign_manager.host
        }/api/campaigns/${campaignId}/predictions?access_token=${auth.getAccessToken()}`,
        force: true,
        transform: res => ({
            [`${campaignId}/postPredictions`]: res.predictions
        }),
        update: {
            [`${campaignId}/postPredictions`]: (prev, next) => next
        }
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/actions/predictions.js
 **/